<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { integrationBrand } from '@/lib/integrations';

const props = withDefaults(
  defineProps<{
    subType?: string | null;
    /** `icon` for dense rows, `pill` adds the brand name. */
    variant?: 'icon' | 'pill';
  }>(),
  { subType: null, variant: 'icon' },
);

const { t } = useI18n();

const brand = computed(() => integrationBrand(props.subType));
const label = computed(() => brand.value?.name ?? t('workspace.pmsBadge'));
const tooltip = computed(() =>
  brand.value
    ? t('workspace.pmsManagedBy', { system: brand.value.name })
    : t('workspace.pmsManaged'),
);
</script>

<template>
  <span
    class="inline-flex shrink-0 items-center gap-1.5"
    :class="
      variant === 'pill'
        ? 'rounded-md border px-2 py-1 text-xs text-muted-foreground'
        : ''
    "
    :title="tooltip"
  >
    <img
      v-if="brand"
      :src="brand.icon"
      :alt="brand.name"
      class="size-3.5 rounded-sm object-contain"
    />
    <span
      v-else-if="variant === 'icon'"
      class="rounded border px-1 text-[10px] font-medium uppercase leading-4 text-muted-foreground"
    >
      {{ label }}
    </span>
    <span v-if="variant === 'pill'">{{ label }}</span>
  </span>
</template>
